module.exports = __webpack_public_path__ + "b81e6a4abbc5525652f664cd8d278f87.svg";